import  Box  from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import styled from '@emotion/styled';
import Paper from '@mui/material/Paper';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { Avatar } from '@mui/material';

const StyledPaper = styled(Paper)`
  padding: 16px 10px;
  width: 100%;
  `;
export const Education: React.FC = ()=>{  
    return(
        <Box
        id="education"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width:'100%'
        }}>
        <Typography variant='h4' sx={{mb:1, mt:1}}>
        EDUCATION
        </Typography>
        <Container component="main" sx={{ width: '100%'}} maxWidth="lg">
          {/* Timeline section */}
        <Timeline position="alternate">

        {/* stage 1 */}
      <TimelineItem>
      <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="right"
          variant="body2"
          color="text.secondary"
        >
          <Typography variant='body1' component="body">Queensland University of Technology</Typography>
          Feb 2022 - Dec 2023
        </TimelineOppositeContent>
        <TimelineSeparator>
            <Avatar alt='QUT' sx={{ width: 60, height: 60 }} src={require('../images/QUT-Logo.png')} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{width:'100%'}}>
          <StyledPaper elevation={5}>
            {/* <Typography variant="body2" component="h2">
              QUT (Queensland University of Technology)
            </Typography> */}
              <Typography variant='body1'>Master of Information Technology</Typography><br/>
            <Typography variant='body2'>Major in Computer Science</Typography>
          </StyledPaper>
        </TimelineContent>
      </TimelineItem>

      {/* stage 2 */}
      <TimelineItem>
      <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="right"
          variant="body2"
          color="text.secondary"
        >
          <Typography variant='body1' component="body">University of Tasmania</Typography>
          Feb 2013 - Jul 2013
        </TimelineOppositeContent>
        <TimelineSeparator>
          <Avatar alt='UTAS' sx={{ width: 60, height: 60 }} src={require('../images/UTAS_logo.png')} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <StyledPaper elevation={3} >
              <Typography variant='body1'>Post-Graduate Certificate in Marketing</Typography><br/>
            <Typography variant='body2'>Major in Marketing</Typography>
          </StyledPaper>
        </TimelineContent>
      </TimelineItem>

      {/* stag 3 */}
      <TimelineItem>
      <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="right"
          variant="body2"
          color="text.secondary"
        >
          <Typography variant='body1' component="body">University of Tasmania</Typography>
          Dec 2011 - Dec 2012
        </TimelineOppositeContent>
        <TimelineSeparator>
        <Avatar alt='UTAS' sx={{ width: 60, height: 60 }} src={require('../images/UTAS_logo.png')} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <StyledPaper elevation={3}>
              <Typography variant='body1'>Bachelor of Business Administration</Typography><br/>
            <Typography variant='body2'>Major in Tourism Management</Typography>
          </StyledPaper>
        </TimelineContent>
      </TimelineItem>
    </Timeline>    
    </Container>
    </Box>    
    );
}